import {useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

function useAxiosInstance() {
    const navigate = useNavigate();
    const [axiosInstance] = useState(() => {
        console.log("API Base Url: " + process.env.REACT_APP_API_BASE_URL)

        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_BASE_URL,
            headers: {
                'Content-Type': 'application/json',
            }
        });

        instance.interceptors.request.use((config) => {
            const token = localStorage.getItem("_MIHEALTHTOKEN");
            if (token) {
                config.headers.Token = token;
            }
            const accessToken = localStorage.getItem("_MIHEALTHACCESSTOKEN");
            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
            return config;
        });

        instance.interceptors.response.use(
            (response) => {
                const {data} = response;
                // Files (CSV, PPG captures) are returned as they are
                if (response.config.responseType === "blob") {
                    return data;
                }
                if (!data.success) {
                    if (data.message === "Unauthorized!") {
                        localStorage.clear();
                        navigate("/");
                    }
                    // Don't hand focus back to the button that sent the request (often the upload
                    // form's Submit): a key typed right after closing would land there.
                    Swal.fire({text: data.message, returnFocus: false});
                    return Promise.reject(response);
                }
                return data.data;
            },
            (error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        Swal.fire(error.response.data?.message || "Please log in again");
                        localStorage.clear();
                        navigate("/");
                    } else if (error.response.status === 403) {
                        Swal.fire("This account can't do that");
                    } else {
                        // Any other HTTP error (400, 404, 500...): say so instead of showing an empty
                        // or stale page. ASP.NET validation errors carry a title, ours a message.
                        const d = error.response.data;
                        Swal.fire({
                            text: d?.message || d?.title || `The server answered HTTP ${error.response.status}.`,
                            returnFocus: false,
                        });
                    }
                } else if (error.request) {
                    // No HTTP response reached the browser: the connection failed, timed out, or a
                    // gateway refused the request without CORS headers (e.g. a size or time limit
                    // in front of the API). This is not a 500 from the API.
                    Swal.fire("No response from the server. The connection failed or was cut by a gateway " +
                        "(upload size or time limit). The browser's Network tab shows the real status.")
                } else {
                    Swal.fire("Error in making the request")
                }
                return Promise.reject(error);
            }
        );
        return instance;
    });

    return axiosInstance;
}

export default useAxiosInstance;